const state = {
	isHeaven: false
}

const getters = {
	getIsHeaven: state => state.isHeaven
}

const mutations = {
	setIsHeaven(state, value) {
    state.isHeaven = value
  }
}

const actions = {
	updateIsHeaven: ({commit}, data) => commit('setIsHeaven', data)
}

export {
  state,
  getters,
  mutations,
  actions
}